<template>
  <div>
    <el-dialog :visible.sync="dialogCodeVisible" top="2%" width="1100px">
      <span slot="title">查看处方</span>
      <div class="create-content" v-loading="loading">
        <div class="create-left">
          <div class="create-left-content">
            <el-form
              ref="formRef"
              :model="formData"
              label-width="70px"
              label-position="left"
            >
              <div class="create-left-content-item">
                <div class="create-left-content-item-value">
                  <el-form-item label="处方类型" prop="issueType">
                    <el-input
                      v-model="formData.issueType"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="create-left-content-item">
                <div class="create-left-content-item-title">基础医疗信息</div>
                <div class="create-left-content-item-value">
                  <el-form-item label="开方机构" prop="issueHospital">
                    <el-input
                      v-model="formData.issueHospital"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="处方编号" prop="number">
                    <el-input
                      v-model="formData.number"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="开具时间" prop="issueTime">
                    <el-input
                      v-model="formData.issueTime"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="科别" prop="department">
                    <el-input
                      v-model="formData.department"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="诊断" prop="diagnose">
                    <el-input
                      v-model="formData.diagnose"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="create-left-content-item">
                <div class="create-left-content-item-title">用药人信息</div>
                <div class="create-left-content-item-value">
                  <el-form-item label="姓名" prop="userName">
                    <el-input
                      v-model="formData.userName"
                      placeholder="可自动识别或手动填写"
                      :disabled="!isUpload"
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="性别" prop="userSex">
                    <el-input
                      v-model="formData.userSex"
                      placeholder="可自动识别或手动填写"
                      :disabled="!isUpload"
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="年龄" prop="userAge">
                    <el-input
                      v-model="formData.userAge"
                      placeholder="可自动识别或手动填写"
                      :disabled="!isUpload"
                      size="mini"
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="create-left-content-item">
                <div class="create-left-content-item-title">
                  <div>药品信息</div>
                  <div class="content-item-title-page">
                    当前第<span style="color: #4076f2">{{ currentPage }}</span
                    >条，共<span style="color: #4076f2">{{ drugTotal }}</span
                    >条
                  </div>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="药品名称" prop="drugName">
                    <el-input
                      v-model="formData.drugName"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="制剂规格" prop="drugSpecification">
                    <el-input
                      v-model="formData.drugSpecification"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="数量" prop="count">
                    <el-input
                      v-model="formData.count"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-value">
                  <el-form-item label="用法用量" prop="usage">
                    <el-input
                      v-model="formData.usage"
                      placeholder="仅自动识别"
                      disabled
                      size="mini"
                    />
                  </el-form-item>
                </div>
                <div class="create-left-content-item-page">
                  <el-pagination
                    background
                    layout="pager"
                    :page-size="1"
                    :total="drugTotal"
                    :current-page.sync="currentPage"
                    @current-change="handleCurrentChange"
                  ></el-pagination>
                </div>
              </div>
              <div class="create-left-content-item">
                <div class="create-left-content-item-title">注意事项</div>
                <div class="create-left-content-item-value">
                  <el-form-item label="注意事项" prop="notes">
                    <el-input
                      v-model="formData.notes"
                      placeholder="可自动识别或手动填写"
                      :disabled="!isUpload"
                      size="mini"
                    />
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <div class="create-right">
          <DocumentUpload
            ref="DocumentUploadRef"
            @loading="loading = $event"
            :isDelete="false"
            :fileList="formData.imageUrls"
          ></DocumentUpload>
        </div>
      </div>
      <div class="create-button">
        <el-button size="mini" type="primary" plain @click="handleProgress"
          >审方进度</el-button
        >
        <el-button
          type="primary"
          plain
          size="mini"
          @click="handleReset"
          v-if="formData.isResetBtnVisible"
          >重新生成</el-button
        >
        <el-button
          type="danger"
          size="mini"
          v-if="formData.isPassRejectBtnVisible"
          @click="handlePassReject(0)"
          >拒绝</el-button
        >
        <el-button
          type="primary"
          style="flex: 1"
          size="mini"
          v-if="formData.isPassRejectBtnVisible"
          @click="handlePassReject(1)"
          >通过
          <i class="el-icon-caret-right"></i>
        </el-button>
      </div>
    </el-dialog>

    <PassReject
      ref="PassRejectRef"
      @submit="handleSubmitPassReject"
    ></PassReject>
    <PassRejectRefuse
      ref="PassRejectRefuseRef"
      @submit="handleSubmitPassReject"
    ></PassRejectRefuse>
    <TipDialog ref="TipDialogRef" @success="handleResetSuccess"></TipDialog>
    <PrescriptionProgress ref="PrescriptionProgressRef"></PrescriptionProgress>
  </div>
</template>

<script>
import DocumentUpload from "@/components/DocumentUpload/index.vue";
import TipDialog from "@/components/TipDialog/index.vue";
import PassReject from "./passReject.vue";
import PassRejectRefuse from "./passRejectRefuse.vue";
import PrescriptionProgress from "./prescriptionProgress.vue";

export default {
  name: "DetailPrescription",
  components: {
    DocumentUpload,
    TipDialog,
    PassReject,
    PassRejectRefuse,
    PrescriptionProgress,
  },
  props: {},
  data() {
    return {
      loading: false,
      dialogCodeVisible: false,
      isUpload: false,
      formData: {
        issueType: "",
        issueHospital: "",
        number: "",
        issueTime: "",
        department: "",
        diagnose: "",
        drugName: "",
        drugSpecification: "",
        count: "",
        usage: "",
        userName: "",
        userSex: "",
        userAge: "",
        notes: "",
      },
      drugTotal: 0,
      currentPage: 1,
    };
  },
  methods: {
    handleProgress() {
      this.$refs.PrescriptionProgressRef.show(this.formData);
    },
    async handleResetSuccess() {
      this.loading = true;
      await this.$api.prescription.ResetPrescription({
        prescriptionId: this.formData.id,
      });
      this.loading = false;
      this.dialogCodeVisible = false;
      this.$emit("submit");
    },
    handleReset() {
      this.$refs.TipDialogRef.show({
        title: "重新生成处方",
        content: "重新生成后处方单状态更改为待审核且可重新提交，是否重新生成？",
        successText: "确认",
        isTime: true,
      });
    },
    handleSubmitPassReject() {
      this.dialogCodeVisible = false;
      this.$emit("submit");
    },
    handlePassReject(auditType) {
      if (auditType === 0) {
        this.$refs.PassRejectRefuseRef.show(this.formData);
      }
      if (auditType === 1) {
        this.$refs.PassRejectRef.show(this.formData);
      }
    },
    handleCurrentChange(val) {
      if (!this.formData.drugDetails || !this.formData.drugDetails[val - 1]) {
        return;
      }
      this.formData.drugName = this.formData.drugDetails[val - 1].drugName;
      this.formData.drugSpecification =
        this.formData.drugDetails[val - 1].drugSpecification;
      this.formData.count = this.formData.drugDetails[val - 1].count;
      this.formData.usage = this.formData.drugDetails[val - 1].usage;
      this.$forceUpdate();
    },
    async show(row) {
      this.dialogCodeVisible = true;
      this.loading = true;
      const { data } = await this.$api.prescription.GetPrescriptionById({
        prescriptionId: row.id,
      });
      this.formData.drugName = data.drugDetails[0].drugName;
      this.formData.drugSpecification = data.drugDetails[0].drugSpecification;
      this.formData.count = data.drugDetails[0].count;
      this.formData.usage = data.drugDetails[0].usage;
      this.drugTotal = data.drugDetails.length;
      this.currentPage = 1;
      this.loading = false;
      Object.assign(this.formData, data);
      this.$forceUpdate();
      this.$nextTick(() => {
        setTimeout(() => {
          const dialogBody = document.querySelector(".create-left-content");
          if (dialogBody) {
            dialogBody.scrollTop = 0;
          }
        }, 100);
      });
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
::v-deep .el-form-item__label {
  display: inline-block !important;
  text-align: justify !important;
  text-align-last: justify !important;
  padding-right: 10px !important;
  position: relative !important;
}
::v-deep .el-form-item__label::before {
  position: absolute !important;
  left: -10px !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
}
</style>
<style lang="scss" scoped>
@import "./detailPrescription.scss";
</style>
